import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { FaEnvelope } from "react-icons/fa";
import Swal from "sweetalert2";
import "./LoginForm.css";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../../api/apiSystem";
import { useTranslation } from "react-i18next";

export default function LoginGuestForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const showSuccessAlert = (message) => {
    Swal.fire({
      icon: 'success',
      title: t("loginGuestForm.success"),
      text: message,
      confirmButtonText: t("loginGuestForm.ok"),
      confirmButtonColor: '#ffc107',
      timer: 3000,
      timerProgressBar: true
    });
  };

  const showErrorAlert = (message) => {
    Swal.fire({
      icon: 'error',
      title: t("loginGuestForm.errorTitle"),
      text: message,
      confirmButtonText: t("loginGuestForm.ok"),
      confirmButtonColor: '#dc3545'
    });
  };

  const handleGuestLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await authAPI.guestLogin({ email });
      
      if (res.success) {
        showSuccessAlert(t("loginGuestForm.successMessage"));
        
        if (res.data?.data?.temp_token) {
          localStorage.setItem("token", res.data.data.temp_token);
          localStorage.setItem("userType", 'guest');
          
          const loggedUser =  res.data.data;
          localStorage.setItem("user", JSON.stringify(loggedUser));
        }

        setTimeout(() => {
          navigate("/"); 
        }, 2000);
        
      } else {
        const errorMessage = res.message || t("loginGuestForm.error.general");
        setError(errorMessage);
        showErrorAlert(errorMessage);
      }
    } catch (err) {
      const errorMessage = t("loginGuestForm.error.general");
      setError(errorMessage);
      showErrorAlert(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-section mt-5">
      <Container>
        <Row className="justify-content-center align-items-center h-100">
          <Col md={6} lg={5}>
            <Card className="shadow-lg p-4 border-0 login-card">
              <Card.Body>
                <h2 className="text-center mb-4 text-dark fw-bold">
                  {t("loginGuestForm.title")}
                </h2>
                <p className="text-center text-muted mb-4">
                  {t("loginGuestForm.guestDescription")}
                </p>

                <Form onSubmit={handleGuestLogin}>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>{t("loginGuestForm.emailLabel")}</Form.Label>
                    <div className="position-relative">
                      <FaEnvelope className="form-icon" />
                      <Form.Control
                        type="email"
                        placeholder={t("loginGuestForm.emailPlaceholder")}
                        className="ps-5"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                  </Form.Group>

                  {error && (
                    <p className="text-danger small text-center">{error}</p>
                  )}

                  <Button
                    variant="warning"
                    type="submit"
                    className="w-100 bg-orange-500 text-white mb-3"
                    disabled={loading || !email}
                  >
                    {loading ? t("loginGuestForm.submitButtonLoading") : t("loginGuestForm.guestLoginButton")}
                  </Button>
                </Form>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}